
$( document ).ready(function() {
    $( "body" ).on( "added.ajaxProduct", function() {
  		console.log( "webstorm added.ajaxProduct" );

      	jQuery.ajax({
          type: 'GET',
          url: '/cart',
          data: {},
          dataType: 'json',
          success: function(e) {
            console.log(e);
              /*document.dispatchEvent(new CustomEvent("added.ajaxProduct",{
              detail: {
                product: e
              }
            }));*/
            let item_count  = e. item_count;
            $(".cart-link__count").html(item_count);
            $(".cart-link__bubble").addClass("cart-link__bubble--visible");
      		$("body").addClass("cart-has-items");

          }
        });

	});
});


function notmyranch(){
    $(".regis_errors").hide();
    $("#CustomerFormCompany").val("");
    $("#CustomerFormAddress1").val("");
    $("#CustomerZipPostalCode").val("");
    $("#CustomerCity").val("");
    if($("#nothere_nein").prop('checked')){
        $("#CustomerFormCompany").prop("readonly", false);
        $("#CustomerFormAddress1").prop("readonly", false);
        $("#CustomerZipPostalCode").prop("readonly", false);
        $("#CustomerCity").prop("readonly", false);
        $("#Telefonnummer").prop("placeholder","Telefonnummer *");
        $("#Telefonnummer").prop("required","required");

        $("#selectranch").val(0);
        $("#selectranch").trigger('change');

        $(".regis_ranch").css('visibility','hidden');
    } else {
        $("#CustomerFormCompany").prop('readonly',true);
        $("#CustomerFormAddress1").prop("readonly", true);
        $("#CustomerZipPostalCode").prop("readonly", true);
        $("#CustomerCity").prop("readonly", true);
        $(".regis_ranch").css('visibility','visible');
        $("#telefonnummerrequired").hide();
        $("#Telefonnummer").prop("placeholder","Telefonnummer");
        $("#Telefonnummer").removeAttr("required");
        $("#Telefonnummer").removeProp("required");
    }
}

function checkRanch(){
    let name = $("#CustomerFormCompany").val();

    var form = $('#create_customer');
    var reportValidity = form[0].reportValidity();

    console.log("reportValidity="+reportValidity);

    if(reportValidity){
        if(name == ""){
            $(".regis_errors").html("Bitte wähle einen Reitstall aus oder gib einen neuen Reitstall ein");
            $(".regis_errors").show();
            return false;
        } else {
            $(".regis_errors").html("");
            $(".regis_errors").hide();
            //window.Shopify.recaptchaV3.addToken(this, "create_customer");
            return true;
        }
    } else {
        return false;
    }
}

function closeModal(mid){
    $("#"+mid).hide();
    $(window).off("click",clickModal);
}
function clickModal(e){
    if($(e.target).hasClass("modalArticle")){
        //console.log(e.target);
        closeModal($(e.target).attr("id"));
    }
}

function showPleaseLogin(){
    $("#pleaseloginmodal").show();
    $(window).on("click",clickModal);
}

function showNotDeliver(){
    $("#nodelivermodal").show();
    $(window).on("click",clickModal);
}

  function gotocart(){
      document.location.href="/cart";
  }

